exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-times[data-v-805ff4e0] {\n  font-size: 1em;\n}\n.progress-bar[data-v-805ff4e0] {\n  margin: 10px 0;\n}\ninput[type=\"file\"][data-v-805ff4e0] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n}\n.v-progress-circular__info[data-v-805ff4e0] {\n  margin-top: -1px;\n}\n", ""]);

// exports
